import { createFileRoute } from '@tanstack/react-router';

import { AdminFlow } from '@/features/admin-integrations/components/AdminFlow';

export const Route = createFileRoute('/_admin/integrations')({
  component: AdminIntegrationsRoute,
});

function AdminIntegrationsRoute() {
  return <AdminFlow />;
}
